var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useState } from "react";
var defaultPublishContext = {
    electionEventId: "",
    electionId: null,
    ballotPublicationId: null,
    setEvent: function () { return undefined; },
    setBallotPublicationId: function () { return undefined; },
};
export var PublishContext = createContext(defaultPublishContext);
export var PublishContextProvider = function (props) {
    var _a = useState(defaultPublishContext.electionEventId), electionEventId = _a[0], setElectionEventId = _a[1];
    var _b = useState(defaultPublishContext.electionId), electionId = _b[0], setElectionId = _b[1];
    var _c = useState(defaultPublishContext.ballotPublicationId), ballotPublicationId = _c[0], setBallotPublicationId = _c[1];
    var setEvent = function (newElectionEventId, newElectionId) {
        if (newElectionEventId !== electionEventId || newElectionId !== electionId) {
            setBallotPublicationId(null);
        }
        setElectionEventId(newElectionEventId);
        setElectionId(newElectionId);
    };
    // Setup the context provider
    return (_jsx(PublishContext.Provider, __assign({ value: {
            electionEventId: electionEventId,
            electionId: electionId,
            ballotPublicationId: ballotPublicationId,
            setEvent: setEvent,
            setBallotPublicationId: setBallotPublicationId,
        } }, { children: props.children })));
};
